/**
 *
 * @module identity
 *
 */

import Check from 'check-types';
import InvalidArgumentException from './../../exception/invalidArgumentException';

const {
    nonEmptyString,
    object
} = Check.assert;

/**
 *
 * @class identity
 *
 */
export default class Identity {

    /**
     *
     * @param {String} email
     * @param {String} id
     * @param {String} partner
     * @param {Object} [attributes={}]
     *
     */
    constructor(email, id, partner, attributes = {}) {

        const errorMessage = {
            ctor: 'Identity(attributes, email, id, partner)',
            get attributes() {
                return `${this.ctor} attributes should be an Object`;
            },
            get email() {
                return `${this.ctor} email should be a String with length`;
            },
            get id() {
                return `${this.ctor} id should be a String with length`;
            },
            get partner() {
                return `${this.ctor} partner should be a String with length`;
            }
        };

        object(attributes, errorMessage.attributes, InvalidArgumentException);
        nonEmptyString(email, errorMessage.email, InvalidArgumentException);
        nonEmptyString(id, errorMessage.id, InvalidArgumentException);
        nonEmptyString(partner, errorMessage.partner, InvalidArgumentException);

        /**
         *
         * @access public
         * @param {Object} attributes
         *
         */
        this.attributes = attributes;

        /**
         *
         * @access public
         * @param {String} email
         *
         */
        this.email = email;

        /**
         *
         * @access public
         * @param {String} id
         *
         */
        this.id = id;

        /**
         *
         * @access public
         * @param {String} partner
         *
         */
        this.partner = partner;

    }

}



// WEBPACK FOOTER //
// ./src/services/identity/bam/identity.js